import SingleColumnContactForm from './SingleColumnContactForm'

export default SingleColumnContactForm
